{
  "ru": {
    "nav": {
      "home": "Планировщик",
      "pricing": "Тарифы"
    },
    "about": {
      "title": "О сервисе",
      "description": "Plan Your Trip — планировщик стоимости поездки: бюджет собирается из перелётов, переездов, ночей и трат, а варианты сравниваются по деньгам и времени.",
      "lead": "Plan Your Trip показывает, во сколько обойдётся поездка целиком — пока её ещё можно изменить.",
      "sections": [
        {
          "h": "Зачем",
          "p": [
            "Цена билета — не цена поездки. К ней добавляются багаж, дорога из аэропорта, ночи, еда и десяток мелочей: каждая по отдельности выглядит несущественной, а вместе они решают, какой вариант дешевле.",
            "Ранний рейс за полцены перестаёт быть дешёвым, когда к нему прибавляются ночное такси и день, потраченный на дорогу. Увидеть это можно только тогда, когда все части поездки сложены в одном месте."
          ]
        },
        {
          "h": "Как устроен",
          "p": [
            "Поездка собирается из блоков: перелёты, переезды, ночи, еда, багаж и прочие траты. Из блоков складываются варианты — обычно их два-три: «через Стамбул», «на день раньше», «поездом вместо самолёта».",
            "Варианты стоят рядом и сравниваются сразу по двум числам — сколько стоит и сколько занимает. Суммы приводятся к одной валюте, а расходы, которые считаются на человека, умножаются на число путешественников."
          ]
        },
        {
          "h": "Чего он не делает",
          "p": [
            "Сервис не ищет рейсы, не продаёт билеты и не получает комиссию с бронирований. Цены в нём ваши: вписанные руками или вытащенные из брони распознаванием.",
            "Поэтому у него нет причины показать один вариант выгоднее другого: он считает и сравнивает, а не торгует."
          ]
        },
        {
          "h": "Где лежат данные",
          "p": [
            "Без аккаунта поездка живёт в браузере и никуда не отправляется. Аккаунт нужен для того, чтобы она открывалась на всех устройствах, чтобы её можно было вести вдвоём и показывать по ссылке.",
            "Публичная ссылка открывает только то, чем поделились, читатель ничего не меняет, а саму ссылку можно отключить."
          ]
        }
      ]
    },
    "how": {
      "title": "Как это работает",
      "description": "Как посчитать бюджет поездки: собрать блоки, разложить варианты, сравнить их по деньгам и времени и поделиться ссылкой. Без регистрации.",
      "lead": "Пять шагов от пустого экрана до ответа: какой вариант дешевле и во что обходится каждый сэкономленный час.",
      "stepsTitle": "Пять шагов",
      "steps": [
        {
          "h": "Соберите библиотеку",
          "p": "В библиотеке лежат части поездки: перелёты, переезды, ночи, еда, багаж, страховка. Рейс не обязательно вписывать руками — вставьте ссылку на бронь или текст письма, и распознавание вытащит даты, аэропорты, время и цену."
        },
        {
          "h": "Разложите варианты",
          "p": "Вариант — это один способ съездить: перетащите блоки на его дорожку в том порядке, в каком они случаются. Порядок и есть маршрут, а промежутки между блоками — ожидания, которые тоже видны."
        },
        {
          "h": "Сравните по деньгам и времени",
          "p": "Варианты стоят рядом в одной таблице: итог, разбивка по типам расходов и общая длительность. Разница видна сразу — и в деньгах, и в часах, потраченных на дорогу."
        },
        {
          "h": "Задайте валюты и путешественников",
          "p": "Суммы могут быть в разных валютах: курсы задаются к базовой один раз, а сравнение идёт в выбранной. Перелёты, багаж, еда и такси умножаются на число путешественников; ночи и переезды — только если отмечены как «на человека»."
        },
        {
          "h": "Поделитесь ссылкой",
          "p": "Публичная ссылка открывает поездку тому, у кого её нет: название, сравнение вариантов и состав каждого. Читатель ничего не меняет, аккаунт ему не нужен, а ссылку можно отключить в любой момент."
        }
      ],
      "faqTitle": "Частые вопросы",
      "faq": [
        {
          "q": "Нужна ли регистрация?",
          "a": "Нет. Без аккаунта поездка сохраняется в браузере, и начать можно сразу. Аккаунт нужен, если поездка должна быть на нескольких устройствах, с соавтором или по публичной ссылке."
        },
        {
          "q": "Сервис ищет и продаёт билеты?",
          "a": "Нет. Он не ищет рейсы, ничего не бронирует и не берёт комиссию. Цены вписываете вы — руками или распознаванием брони, — а сервис их складывает и сравнивает."
        },
        {
          "q": "Откуда берутся цены?",
          "a": "Из того, что вы видите у перевозчика или в своей броне. Ни одна сумма не подставляется «примерной»: цена с потолка молча уехала бы в итог и наврала бы в сравнении."
        },
        {
          "q": "Как считается поездка на нескольких человек?",
          "a": "Перелёты, багаж, еда и такси умножаются на число путешественников. Ночи и переезды считаются общими, пока вы не отметите их как «на человека»: номер на двоих стоит одинаково независимо от того, сколько в нём спит."
        },
        {
          "q": "Можно ли считать в нескольких валютах?",
          "a": "Да. У каждой суммы своя валюта, курсы задаются к базовой, а итог и сравнение показываются в выбранной."
        },
        {
          "q": "Что видит человек, которому я отправил ссылку?",
          "a": "Название поездки, таблицу сравнения и состав каждого варианта — в том виде и на том языке, в котором вы поделились. Менять он ничего не может, а ссылку можно отключить."
        },
        {
          "q": "Сколько это стоит?",
          "a": "Основное бесплатно и без ограничения по времени: поездки, варианты, сравнение и ссылки. Платный тариф поднимает лимиты и добавляет возможности — что именно входит, написано на странице тарифов."
        }
      ],
      "cta": "Открыть планировщик"
    },
    "templates": {
      "title": "Шаблоны поездок",
      "description": "Готовые наборы расходов для частых поездок: уикенд, неделя у моря, командировка, два города, горы. Открываются в планировщике одним нажатием.",
      "lead": "Шаблон — это не готовая поездка с ценами, а список того, что в такой поездке обычно есть. Цены проставляете вы: сумма, взятая с потолка, молча уехала бы в итог и наврала бы в сравнении.",
      "listTitle": "Пять шаблонов",
      "includesTitle": "Что входит",
      "addTitle": "Что стоит добавить",
      "cta": "Собрать поездку по шаблону",
      "ctaNote": "Шаблон откроется в планировщике: блоки расставлены, цены пустые.",
      "backToList": "Все шаблоны",
      "items": {
        "weekend": {
          "title": "Уикенд на два дня",
          "description": "Из чего складывается бюджет поездки на выходные: дорога из аэропорта, две ночи, еда и такси. Шаблон открывается в планировщике.",
          "lead": "Короткая поездка, в которой перелёт кажется главной тратой. На деле две ночи, еда и дорога из аэропорта вместе часто перевешивают билет.",
          "includes": [
            "Переезд из аэропорта в город — час",
            "Две ночи в городе",
            "Еда на три дня",
            "Такси по городу — две поездки",
            "Страховка"
          ],
          "add": "Багаж, если летите не с ручной кладью, и обратный переезд в аэропорт, если считаете его отдельно."
        },
        "beach": {
          "title": "Неделя у моря",
          "description": "Бюджет недели на одном месте: трансфер до отеля, семь ночей, еда, экскурсии, связь и страховка. Шаблон открывается в планировщике.",
          "lead": "Семь ночей на одном месте: перелёт здесь считается один раз, а всё остальное умножается на дни — поэтому итог решают не билеты, а ночь и день.",
          "includes": [
            "Трансфер из аэропорта до отеля — 45 минут",
            "Семь ночей",
            "Еда на семь дней",
            "Экскурсии и билеты",
            "Связь или eSIM",
            "Страховка"
          ],
          "add": "Багаж, аренду машины и депозит за неё, если поездка не только про пляж."
        },
        "business": {
          "title": "Командировка",
          "description": "Бюджет поездки по делам: три ночи, такси, еда, связь и страховка — то, что потом идёт в отчёт. Шаблон открывается в планировщике.",
          "lead": "Поездка по делам считается иначе: ночей мало, а такси много, и заранее нужна не средняя оценка, а сумма, которую примет бухгалтерия.",
          "includes": [
            "Переезд из аэропорта — час",
            "Три ночи",
            "Такси по городу — четыре поездки",
            "Еда на четыре дня",
            "Связь или eSIM",
            "Страховка"
          ],
          "add": "Багаж и то, что компания оплачивает отдельно: это удобно держать вторым вариантом рядом."
        },
        "two-cities": {
          "title": "Два города за поездку",
          "description": "Бюджет поездки по двум городам: по три ночи в каждом, переезд между ними, еда и такси. Шаблон открывается в планировщике.",
          "lead": "Два города в одной поездке добавляют то, чего нет в поездке в один: переезд посередине, который стоит и денег, и половины дня.",
          "includes": [
            "Три ночи в первом городе",
            "Переезд между городами — четыре часа",
            "Три ночи во втором городе",
            "Еда на семь дней",
            "Такси — четыре поездки",
            "Страховка"
          ],
          "add": "Багаж, а если города в разных странах — визу и страховку, которая покрывает обе."
        },
        "mountains": {
          "title": "Горы и лыжи",
          "description": "Бюджет поездки в горы: пять ночей у склона, подъёмник, прокат снаряжения, еда и страховка. Шаблон открывается в планировщике.",
          "lead": "В горах дорого не жильё, а день на склоне: подъёмник и прокат считаются по дням и за неделю догоняют перелёт.",
          "includes": [
            "Переезд из аэропорта — час",
            "Пять ночей у склона",
            "Подъёмник на пять дней",
            "Прокат снаряжения на пять дней",
            "Еда на шесть дней",
            "Страховка"
          ],
          "add": "Багаж за лыжи, уроки инструктора и страховку, которая покрывает катание."
        }
      }
    }
  },
  "en": {
    "nav": {
      "home": "Planner",
      "pricing": "Pricing"
    },
    "about": {
      "title": "About",
      "description": "Plan Your Trip is a trip cost planner: build the budget from flights, transfers, nights and extras, and compare the options by money and time.",
      "lead": "Plan Your Trip shows what a trip costs as a whole — while it can still be changed.",
      "sections": [
        {
          "h": "Why",
          "p": [
            "A ticket price is not a trip price. Baggage, the ride from the airport, nights, food and a dozen small things get added to it: each looks negligible on its own, together they decide which option is cheaper.",
            "An early flight at half the price stops being cheap once a night taxi and a day spent travelling are added to it. That only becomes visible when every part of the trip sits in one place."
          ]
        },
        {
          "h": "How it is built",
          "p": [
            "A trip is assembled from blocks: flights, transfers, nights, food, baggage and other spending. Blocks make up options — usually two or three: «via Istanbul», «a day earlier», «by train instead of a plane».",
            "The options stand side by side and are compared by two numbers at once: what it costs and how long it takes. Amounts are converted to a single currency, and the costs counted per person are multiplied by the number of travellers."
          ]
        },
        {
          "h": "What it does not do",
          "p": [
            "The service does not search for flights, does not sell tickets and takes no booking commission. The prices in it are yours: typed in by hand or pulled out of a booking by recognition.",
            "So it has no reason to make one option look better than another: it counts and compares, it does not sell."
          ]
        },
        {
          "h": "Where the data lives",
          "p": [
            "Without an account a trip lives in the browser and goes nowhere. An account is what makes it open on every device, lets two people keep it together and lets it be shown by a link.",
            "A public link opens only what was shared, the reader changes nothing, and the link itself can be switched off."
          ]
        }
      ]
    },
    "how": {
      "title": "How it works",
      "description": "How to work out a trip budget: collect the blocks, lay out the options, compare them by money and time and share a link. No sign-up needed.",
      "lead": "Five steps from an empty screen to an answer: which option is cheaper, and what every saved hour actually costs.",
      "stepsTitle": "Five steps",
      "steps": [
        {
          "h": "Fill the library",
          "p": "The library holds the parts of a trip: flights, transfers, nights, food, baggage, insurance. A flight does not have to be typed in — paste a booking link or the text of the confirmation email and recognition pulls out the dates, airports, times and price."
        },
        {
          "h": "Lay out the options",
          "p": "An option is one way to make the trip: drag the blocks onto its lane in the order in which they happen. The order is the route, and the gaps between blocks are waiting time, which is visible too."
        },
        {
          "h": "Compare by money and time",
          "p": "The options stand side by side in one table: the total, the breakdown by kind of spending and the overall duration. The difference shows up at once — both in money and in the hours spent travelling."
        },
        {
          "h": "Set currencies and travellers",
          "p": "Amounts can be in different currencies: the rates are set against the base one once, and the comparison runs in the currency you choose. Flights, baggage, food and taxis are multiplied by the number of travellers; nights and transfers only if they are marked as per person."
        },
        {
          "h": "Share a link",
          "p": "A public link opens the trip for someone who does not have it: the name, the comparison of the options and what each of them is made of. The reader changes nothing, needs no account, and the link can be switched off at any moment."
        }
      ],
      "faqTitle": "Common questions",
      "faq": [
        {
          "q": "Do I need to sign up?",
          "a": "No. Without an account the trip is saved in the browser and you can start right away. An account is needed if the trip has to be on several devices, shared with a co-author or opened by a public link."
        },
        {
          "q": "Does the service search for and sell tickets?",
          "a": "No. It does not search for flights, books nothing and takes no commission. You enter the prices — by hand or through booking recognition — and the service adds them up and compares them."
        },
        {
          "q": "Where do the prices come from?",
          "a": "From what you see at the carrier or in your own booking. No amount is filled in as an estimate: a made-up price would quietly reach the total and lie in the comparison."
        },
        {
          "q": "How is a trip for several people counted?",
          "a": "Flights, baggage, food and taxis are multiplied by the number of travellers. Nights and transfers are counted as shared until you mark them as per person: a double room costs the same whoever sleeps in it."
        },
        {
          "q": "Can I use several currencies?",
          "a": "Yes. Every amount has its own currency, the rates are set against the base one, and the total and the comparison are shown in the currency you choose."
        },
        {
          "q": "What does the person I sent the link to see?",
          "a": "The name of the trip, the comparison table and what each option is made of — in the look and the language you shared it with. They cannot change anything, and the link can be switched off."
        },
        {
          "q": "What does it cost?",
          "a": "The main things are free with no time limit: trips, options, comparison and links. A paid plan raises the limits and adds more — what exactly is included is written on the pricing page."
        }
      ],
      "cta": "Open the planner"
    },
    "templates": {
      "title": "Trip templates",
      "description": "Ready-made sets of costs for common trips: a weekend, a week by the sea, a business trip, two cities, the mountains. One tap opens them in the planner.",
      "lead": "A template is not a finished trip with prices, it is the list of what such a trip usually contains. You put the prices in: an amount taken out of thin air would quietly reach the total and lie in the comparison.",
      "listTitle": "Five templates",
      "includesTitle": "What is inside",
      "addTitle": "Worth adding",
      "cta": "Build a trip from this template",
      "ctaNote": "The template opens in the planner: the blocks are laid out, the prices are empty.",
      "backToList": "All templates",
      "items": {
        "weekend": {
          "title": "A two-day weekend",
          "description": "What a weekend trip budget is made of: the ride from the airport, two nights, food and taxis. The template opens in the planner.",
          "lead": "A short trip where the flight looks like the main expense. In practice two nights, food and the ride from the airport together often outweigh the ticket.",
          "includes": [
            "Transfer from the airport to the city — one hour",
            "Two nights in the city",
            "Food for three days",
            "Taxis around the city — two rides",
            "Insurance"
          ],
          "add": "Baggage, if you are not travelling with cabin bags only, and the ride back to the airport if you count it separately."
        },
        "beach": {
          "title": "A week by the sea",
          "description": "The budget of a week in one place: the transfer to the hotel, seven nights, food, excursions, connectivity and insurance. The template opens in the planner.",
          "lead": "Seven nights in one place: the flight is counted once here and everything else is multiplied by days — so the total is decided by a night and a day, not by the tickets.",
          "includes": [
            "Transfer from the airport to the hotel — 45 minutes",
            "Seven nights",
            "Food for seven days",
            "Excursions and tickets",
            "Connectivity or an eSIM",
            "Insurance"
          ],
          "add": "Baggage, a rental car and its deposit, if the trip is not only about the beach."
        },
        "business": {
          "title": "A business trip",
          "description": "The budget of a trip on business: three nights, taxis, food, connectivity and insurance — the things that later go into the expense report. The template opens in the planner.",
          "lead": "A business trip is counted differently: few nights and many taxis, and what is needed up front is not an average estimate but a sum the finance department will accept.",
          "includes": [
            "Transfer from the airport — one hour",
            "Three nights",
            "Taxis around the city — four rides",
            "Food for four days",
            "Connectivity or an eSIM",
            "Insurance"
          ],
          "add": "Baggage and whatever the company pays for separately: that is easiest to keep as a second option next to the first."
        },
        "two-cities": {
          "title": "Two cities in one trip",
          "description": "The budget of a trip through two cities: three nights in each, the transfer between them, food and taxis. The template opens in the planner.",
          "lead": "Two cities in one trip add what a single-city trip does not have: a transfer in the middle that costs both money and half a day.",
          "includes": [
            "Three nights in the first city",
            "Transfer between the cities — four hours",
            "Three nights in the second city",
            "Food for seven days",
            "Taxis — four rides",
            "Insurance"
          ],
          "add": "Baggage, and if the cities are in different countries, a visa and insurance that covers both."
        },
        "mountains": {
          "title": "Mountains and skiing",
          "description": "The budget of a trip to the mountains: five nights by the slope, the lift pass, gear rental, food and insurance. The template opens in the planner.",
          "lead": "In the mountains it is not the lodging that is expensive but the day on the slope: the lift pass and the rental are counted per day and over a week they catch up with the flight.",
          "includes": [
            "Transfer from the airport — one hour",
            "Five nights by the slope",
            "A five-day lift pass",
            "Gear rental for five days",
            "Food for six days",
            "Insurance"
          ],
          "add": "Baggage for the skis, instructor lessons and insurance that actually covers skiing."
        }
      }
    }
  },
  "es": {
    "nav": {
      "home": "Planificador",
      "pricing": "Precios"
    },
    "about": {
      "title": "Sobre el servicio",
      "description": "Plan Your Trip es un planificador del coste del viaje: arma el presupuesto con vuelos, traslados, noches y gastos, y compara las opciones por dinero y tiempo.",
      "lead": "Plan Your Trip muestra cuánto cuesta el viaje entero, mientras todavía se puede cambiar.",
      "sections": [
        {
          "h": "Para qué",
          "p": [
            "El precio del billete no es el precio del viaje. Se le suman la maleta, el trayecto desde el aeropuerto, las noches, la comida y una docena de detalles: cada uno parece insignificante por separado, pero juntos deciden qué opción sale más barata.",
            "Un vuelo de madrugada a mitad de precio deja de ser barato cuando se le añaden el taxi nocturno y un día perdido en el camino. Eso solo se ve cuando todas las partes del viaje están en un mismo sitio."
          ]
        },
        {
          "h": "Cómo está hecho",
          "p": [
            "El viaje se arma con bloques: vuelos, traslados, noches, comida, equipaje y demás gastos. Con los bloques se forman opciones, normalmente dos o tres: «vía Estambul», «un día antes», «en tren en vez de avión».",
            "Las opciones quedan una al lado de otra y se comparan por dos números a la vez: cuánto cuesta y cuánto dura. Los importes se llevan a una sola moneda y los gastos que se cuentan por persona se multiplican por el número de viajeros."
          ]
        },
        {
          "h": "Lo que no hace",
          "p": [
            "El servicio no busca vuelos, no vende billetes y no cobra comisión por reservas. Los precios son los tuyos: escritos a mano o extraídos de una reserva por el reconocimiento.",
            "Por eso no tiene motivo para hacer que una opción parezca mejor que otra: calcula y compara, no vende."
          ]
        },
        {
          "h": "Dónde están los datos",
          "p": [
            "Sin cuenta el viaje vive en el navegador y no sale de ahí. La cuenta sirve para que se abra en todos los dispositivos, para llevarlo entre dos y para enseñarlo con un enlace.",
            "El enlace público abre solo lo compartido, quien lo recibe no cambia nada y el enlace se puede desactivar."
          ]
        }
      ]
    },
    "how": {
      "title": "Cómo funciona",
      "description": "Cómo calcular el presupuesto de un viaje: reúne los bloques, arma las opciones, compáralas por dinero y tiempo y comparte un enlace. Sin registro.",
      "lead": "Cinco pasos desde una pantalla vacía hasta la respuesta: qué opción sale más barata y cuánto cuesta cada hora ahorrada.",
      "stepsTitle": "Cinco pasos",
      "steps": [
        {
          "h": "Reúne la biblioteca",
          "p": "La biblioteca guarda las partes del viaje: vuelos, traslados, noches, comida, equipaje, seguro. El vuelo no hace falta escribirlo: pega el enlace de la reserva o el texto del correo y el reconocimiento saca las fechas, los aeropuertos, las horas y el precio."
        },
        {
          "h": "Arma las opciones",
          "p": "Una opción es una manera de hacer el viaje: arrastra los bloques a su carril en el orden en que ocurren. El orden es la ruta, y los huecos entre bloques son esperas, que también se ven."
        },
        {
          "h": "Compara por dinero y tiempo",
          "p": "Las opciones quedan una al lado de otra en una tabla: el total, el desglose por tipo de gasto y la duración. La diferencia se ve de golpe, en dinero y en horas de camino."
        },
        {
          "h": "Fija monedas y viajeros",
          "p": "Los importes pueden estar en monedas distintas: los cambios se fijan una vez respecto a la base y la comparación va en la que elijas. Vuelos, equipaje, comida y taxis se multiplican por el número de viajeros; noches y traslados solo si los marcas por persona."
        },
        {
          "h": "Comparte un enlace",
          "p": "El enlace público abre el viaje a quien no lo tiene: el nombre, la comparación de las opciones y de qué se compone cada una. Quien lo lee no cambia nada, no necesita cuenta y el enlace se puede desactivar cuando quieras."
        }
      ],
      "faqTitle": "Preguntas frecuentes",
      "faq": [
        {
          "q": "¿Hace falta registrarse?",
          "a": "No. Sin cuenta el viaje se guarda en el navegador y puedes empezar enseguida. La cuenta hace falta si el viaje tiene que estar en varios dispositivos, con un coautor o abierto por enlace público."
        },
        {
          "q": "¿El servicio busca y vende billetes?",
          "a": "No. No busca vuelos, no reserva nada y no cobra comisión. Los precios los pones tú —a mano o con el reconocimiento de la reserva— y el servicio los suma y los compara."
        },
        {
          "q": "¿De dónde salen los precios?",
          "a": "De lo que ves en la aerolínea o en tu propia reserva. Ningún importe se rellena «a ojo»: un precio inventado llegaría callado al total y mentiría en la comparación."
        },
        {
          "q": "¿Cómo se cuenta un viaje para varias personas?",
          "a": "Vuelos, equipaje, comida y taxis se multiplican por el número de viajeros. Las noches y los traslados se cuentan compartidos hasta que los marcas por persona: una habitación doble cuesta lo mismo duerma quien duerma en ella."
        },
        {
          "q": "¿Puedo usar varias monedas?",
          "a": "Sí. Cada importe tiene su moneda, los cambios se fijan respecto a la base, y el total y la comparación se muestran en la que elijas."
        },
        {
          "q": "¿Qué ve la persona a la que envío el enlace?",
          "a": "El nombre del viaje, la tabla de comparación y de qué se compone cada opción, con el aspecto y el idioma con los que lo compartiste. No puede cambiar nada y el enlace se puede desactivar."
        },
        {
          "q": "¿Cuánto cuesta?",
          "a": "Lo principal es gratis y sin límite de tiempo: viajes, opciones, comparación y enlaces. El plan de pago sube los límites y añade más; qué incluye exactamente está en la página de precios."
        }
      ],
      "cta": "Abrir el planificador"
    },
    "templates": {
      "title": "Plantillas de viaje",
      "description": "Conjuntos de gastos ya preparados para los viajes más habituales: un fin de semana, una semana de playa, un viaje de trabajo, dos ciudades, la montaña.",
      "lead": "Una plantilla no es un viaje ya hecho con precios, es la lista de lo que ese tipo de viaje suele tener. Los precios los pones tú: un importe inventado llegaría callado al total y mentiría en la comparación.",
      "listTitle": "Cinco plantillas",
      "includesTitle": "Qué incluye",
      "addTitle": "Qué conviene añadir",
      "cta": "Armar un viaje con esta plantilla",
      "ctaNote": "La plantilla se abre en el planificador: los bloques están puestos y los precios, vacíos.",
      "backToList": "Todas las plantillas",
      "items": {
        "weekend": {
          "title": "Fin de semana de dos días",
          "description": "De qué se compone el presupuesto de un fin de semana: el trayecto desde el aeropuerto, dos noches, la comida y los taxis. La plantilla se abre en el planificador.",
          "lead": "Un viaje corto en el que el vuelo parece el gasto principal. En la práctica, dos noches, la comida y el trayecto desde el aeropuerto juntos suelen pesar más que el billete.",
          "includes": [
            "Traslado del aeropuerto a la ciudad: una hora",
            "Dos noches en la ciudad",
            "Comida para tres días",
            "Taxis por la ciudad: dos trayectos",
            "Seguro"
          ],
          "add": "El equipaje, si no viajas solo con cabina, y la vuelta al aeropuerto si la cuentas aparte."
        },
        "beach": {
          "title": "Una semana de playa",
          "description": "El presupuesto de una semana en un mismo sitio: traslado al hotel, siete noches, comida, excursiones, conectividad y seguro. La plantilla se abre en el planificador.",
          "lead": "Siete noches en un mismo sitio: el vuelo se cuenta una vez y todo lo demás se multiplica por días, así que el total lo deciden la noche y el día, no los billetes.",
          "includes": [
            "Traslado del aeropuerto al hotel: 45 minutos",
            "Siete noches",
            "Comida para siete días",
            "Excursiones y entradas",
            "Conectividad o eSIM",
            "Seguro"
          ],
          "add": "El equipaje, el coche de alquiler y su fianza, si el viaje no es solo playa."
        },
        "business": {
          "title": "Viaje de trabajo",
          "description": "El presupuesto de un viaje por trabajo: tres noches, taxis, comida, conectividad y seguro, lo que luego va al informe de gastos. La plantilla se abre en el planificador.",
          "lead": "Un viaje de trabajo se cuenta distinto: pocas noches y muchos taxis, y por adelantado no hace falta una estimación media, sino una cifra que administración acepte.",
          "includes": [
            "Traslado desde el aeropuerto: una hora",
            "Tres noches",
            "Taxis por la ciudad: cuatro trayectos",
            "Comida para cuatro días",
            "Conectividad o eSIM",
            "Seguro"
          ],
          "add": "El equipaje y lo que la empresa paga aparte: eso es más cómodo tenerlo como una segunda opción al lado."
        },
        "two-cities": {
          "title": "Dos ciudades en un viaje",
          "description": "El presupuesto de un viaje por dos ciudades: tres noches en cada una, el traslado entre ellas, la comida y los taxis. La plantilla se abre en el planificador.",
          "lead": "Dos ciudades en un viaje añaden lo que no tiene un viaje a una sola: un traslado en medio que cuesta dinero y medio día.",
          "includes": [
            "Tres noches en la primera ciudad",
            "Traslado entre las ciudades: cuatro horas",
            "Tres noches en la segunda ciudad",
            "Comida para siete días",
            "Taxis: cuatro trayectos",
            "Seguro"
          ],
          "add": "El equipaje y, si las ciudades están en países distintos, el visado y un seguro que cubra ambos."
        },
        "mountains": {
          "title": "Montaña y esquí",
          "description": "El presupuesto de un viaje a la montaña: cinco noches junto a la pista, forfait, alquiler de material, comida y seguro. La plantilla se abre en el planificador.",
          "lead": "En la montaña lo caro no es el alojamiento, sino el día en la pista: el forfait y el alquiler se cuentan por días y en una semana alcanzan al vuelo.",
          "includes": [
            "Traslado desde el aeropuerto: una hora",
            "Cinco noches junto a la pista",
            "Forfait de cinco días",
            "Alquiler de material para cinco días",
            "Comida para seis días",
            "Seguro"
          ],
          "add": "El equipaje de los esquís, las clases con monitor y un seguro que cubra de verdad el esquí."
        }
      }
    }
  },
  "el": {
    "nav": {
      "home": "Εφαρμογή",
      "pricing": "Τιμές"
    },
    "about": {
      "title": "Σχετικά με την υπηρεσία",
      "description": "Το Plan Your Trip υπολογίζει το κόστος του ταξιδιού: φτιάχνει τον προϋπολογισμό από πτήσεις, μεταφορές, διανυκτερεύσεις και έξοδα και συγκρίνει τις επιλογές σε χρήμα και χρόνο.",
      "lead": "Το Plan Your Trip δείχνει πόσο κοστίζει το ταξίδι συνολικά — όσο ακόμη μπορεί να αλλάξει.",
      "sections": [
        {
          "h": "Γιατί",
          "p": [
            "Η τιμή του εισιτηρίου δεν είναι η τιμή του ταξιδιού. Προστίθενται οι αποσκευές, η διαδρομή από το αεροδρόμιο, οι διανυκτερεύσεις, το φαγητό και δώδεκα μικρά έξοδα: το καθένα μοιάζει ασήμαντο χωριστά, μαζί όμως κρίνουν ποια επιλογή βγαίνει φθηνότερη.",
            "Μια πρωινή πτήση στη μισή τιμή παύει να είναι φθηνή μόλις προστεθούν το νυχτερινό ταξί και μια μέρα χαμένη στον δρόμο. Αυτό φαίνεται μόνο όταν όλα τα κομμάτια του ταξιδιού βρίσκονται σε ένα σημείο."
          ]
        },
        {
          "h": "Πώς είναι φτιαγμένο",
          "p": [
            "Το ταξίδι συναρμολογείται από μπλοκ: πτήσεις, μεταφορές, διανυκτερεύσεις, φαγητό, αποσκευές και άλλα έξοδα. Από τα μπλοκ βγαίνουν οι επιλογές — συνήθως δύο ή τρεις: «μέσω Κωνσταντινούπολης», «μια μέρα νωρίτερα», «με τρένο αντί για αεροπλάνο».",
            "Οι επιλογές στέκονται δίπλα δίπλα και συγκρίνονται με δύο αριθμούς μαζί: πόσο κοστίζουν και πόσο κρατούν. Τα ποσά μετατρέπονται σε ένα νόμισμα και τα έξοδα που μετριούνται κατ' άτομο πολλαπλασιάζονται με τον αριθμό των ταξιδιωτών."
          ]
        },
        {
          "h": "Τι δεν κάνει",
          "p": [
            "Η υπηρεσία δεν ψάχνει πτήσεις, δεν πουλάει εισιτήρια και δεν παίρνει προμήθεια από κρατήσεις. Οι τιμές είναι δικές σου: γραμμένες με το χέρι ή βγαλμένες από μια κράτηση με αναγνώριση.",
            "Γι' αυτό δεν έχει λόγο να δείξει τη μία επιλογή καλύτερη από την άλλη: υπολογίζει και συγκρίνει, δεν πουλάει."
          ]
        },
        {
          "h": "Πού μένουν τα δεδομένα",
          "p": [
            "Χωρίς λογαριασμό το ταξίδι μένει στον περιηγητή και δεν φεύγει πουθενά. Ο λογαριασμός χρειάζεται για να ανοίγει σε κάθε συσκευή, να το κρατάτε δύο άτομα μαζί και να το δείχνεις με σύνδεσμο.",
            "Ο δημόσιος σύνδεσμος ανοίγει μόνο ό,τι μοιράστηκες, ο αναγνώστης δεν αλλάζει τίποτα, και ο ίδιος ο σύνδεσμος απενεργοποιείται."
          ]
        }
      ]
    },
    "how": {
      "title": "Πώς λειτουργεί",
      "description": "Πώς υπολογίζεις τον προϋπολογισμό ενός ταξιδιού: μάζεψε τα μπλοκ, φτιάξε τις επιλογές, σύγκρινέ τες σε χρήμα και χρόνο και μοιράσου έναν σύνδεσμο. Χωρίς εγγραφή.",
      "lead": "Πέντε βήματα από την άδεια οθόνη ως την απάντηση: ποια επιλογή βγαίνει φθηνότερη και πόσο κοστίζει κάθε ώρα που κερδίζεις.",
      "stepsTitle": "Πέντε βήματα",
      "steps": [
        {
          "h": "Γέμισε τη βιβλιοθήκη",
          "p": "Η βιβλιοθήκη κρατά τα κομμάτια του ταξιδιού: πτήσεις, μεταφορές, διανυκτερεύσεις, φαγητό, αποσκευές, ασφάλεια. Την πτήση δεν χρειάζεται να τη γράψεις: επικόλλησε τον σύνδεσμο της κράτησης ή το κείμενο του email και η αναγνώριση βγάζει ημερομηνίες, αεροδρόμια, ώρες και τιμή."
        },
        {
          "h": "Φτιάξε τις επιλογές",
          "p": "Μια επιλογή είναι ένας τρόπος να γίνει το ταξίδι: σύρε τα μπλοκ στη γραμμή της με τη σειρά που συμβαίνουν. Η σειρά είναι η διαδρομή, και τα κενά ανάμεσα στα μπλοκ είναι αναμονές — φαίνονται κι αυτές."
        },
        {
          "h": "Σύγκρινε σε χρήμα και χρόνο",
          "p": "Οι επιλογές μπαίνουν δίπλα δίπλα σε έναν πίνακα: σύνολο, ανάλυση ανά είδος εξόδου και συνολική διάρκεια. Η διαφορά φαίνεται αμέσως — και σε χρήματα και σε ώρες δρόμου."
        },
        {
          "h": "Όρισε νομίσματα και ταξιδιώτες",
          "p": "Τα ποσά μπορεί να είναι σε διαφορετικά νομίσματα: οι ισοτιμίες ορίζονται μία φορά ως προς το βασικό και η σύγκριση γίνεται σε όποιο διαλέξεις. Πτήσεις, αποσκευές, φαγητό και ταξί πολλαπλασιάζονται με τον αριθμό των ταξιδιωτών· διανυκτερεύσεις και μεταφορές μόνο αν τις σημειώσεις ως κατ' άτομο."
        },
        {
          "h": "Μοιράσου έναν σύνδεσμο",
          "p": "Ο δημόσιος σύνδεσμος ανοίγει το ταξίδι σε όποιον δεν το έχει: όνομα, σύγκριση των επιλογών και από τι αποτελείται η καθεμία. Ο αναγνώστης δεν αλλάζει τίποτα, δεν χρειάζεται λογαριασμό, και ο σύνδεσμος απενεργοποιείται όποτε θες."
        }
      ],
      "faqTitle": "Συχνές ερωτήσεις",
      "faq": [
        {
          "q": "Χρειάζεται εγγραφή;",
          "a": "Όχι. Χωρίς λογαριασμό το ταξίδι αποθηκεύεται στον περιηγητή και ξεκινάς αμέσως. Ο λογαριασμός χρειάζεται αν το ταξίδι πρέπει να είναι σε πολλές συσκευές, με συνεργάτη ή ανοιχτό με δημόσιο σύνδεσμο."
        },
        {
          "q": "Η υπηρεσία ψάχνει και πουλάει εισιτήρια;",
          "a": "Όχι. Δεν ψάχνει πτήσεις, δεν κάνει κρατήσεις και δεν παίρνει προμήθεια. Τις τιμές τις βάζεις εσύ — με το χέρι ή με αναγνώριση κράτησης — και η υπηρεσία τις αθροίζει και τις συγκρίνει."
        },
        {
          "q": "Από πού έρχονται οι τιμές;",
          "a": "Από ό,τι βλέπεις στον μεταφορέα ή στη δική σου κράτηση. Κανένα ποσό δεν μπαίνει «κατά προσέγγιση»: μια τιμή στην τύχη θα έφτανε αθόρυβα στο σύνολο και θα έλεγε ψέματα στη σύγκριση."
        },
        {
          "q": "Πώς μετριέται ταξίδι για πολλά άτομα;",
          "a": "Πτήσεις, αποσκευές, φαγητό και ταξί πολλαπλασιάζονται με τον αριθμό των ταξιδιωτών. Διανυκτερεύσεις και μεταφορές μετριούνται κοινές, μέχρι να τις σημειώσεις ως κατ' άτομο: το δίκλινο κοστίζει το ίδιο όποιος κι αν κοιμάται μέσα."
        },
        {
          "q": "Μπορώ να χρησιμοποιήσω πολλά νομίσματα;",
          "a": "Ναι. Κάθε ποσό έχει το δικό του νόμισμα, οι ισοτιμίες ορίζονται ως προς το βασικό, και το σύνολο με τη σύγκριση εμφανίζονται σε όποιο διαλέξεις."
        },
        {
          "q": "Τι βλέπει αυτός στον οποίο έστειλα τον σύνδεσμο;",
          "a": "Το όνομα του ταξιδιού, τον πίνακα σύγκρισης και από τι αποτελείται κάθε επιλογή — στη μορφή και στη γλώσσα που τα μοιράστηκες. Δεν μπορεί να αλλάξει τίποτα, και ο σύνδεσμος απενεργοποιείται."
        },
        {
          "q": "Πόσο κοστίζει;",
          "a": "Τα βασικά είναι δωρεάν χωρίς χρονικό όριο: ταξίδια, επιλογές, σύγκριση και σύνδεσμοι. Το πληρωμένο πακέτο ανεβάζει τα όρια και προσθέτει κι άλλα — τι ακριβώς περιλαμβάνει γράφεται στη σελίδα των τιμών."
        }
      ],
      "cta": "Άνοιγμα της εφαρμογής"
    },
    "templates": {
      "title": "Πρότυπα ταξιδιών",
      "description": "Έτοιμα σύνολα εξόδων για τα συνηθισμένα ταξίδια: σαββατοκύριακο, εβδομάδα στη θάλασσα, επαγγελματικό ταξίδι, δύο πόλεις, βουνό.",
      "lead": "Το πρότυπο δεν είναι έτοιμο ταξίδι με τιμές, είναι η λίστα με ό,τι έχει συνήθως ένα τέτοιο ταξίδι. Τις τιμές τις βάζεις εσύ: ένα ποσό στην τύχη θα έφτανε αθόρυβα στο σύνολο και θα έλεγε ψέματα στη σύγκριση.",
      "listTitle": "Πέντε πρότυπα",
      "includesTitle": "Τι περιλαμβάνει",
      "addTitle": "Τι αξίζει να προσθέσεις",
      "cta": "Φτιάξε ταξίδι από αυτό το πρότυπο",
      "ctaNote": "Το πρότυπο ανοίγει στην εφαρμογή: τα μπλοκ είναι τοποθετημένα, οι τιμές άδειες.",
      "backToList": "Όλα τα πρότυπα",
      "items": {
        "weekend": {
          "title": "Σαββατοκύριακο δύο ημερών",
          "description": "Από τι αποτελείται ο προϋπολογισμός ενός σαββατοκύριακου: η διαδρομή από το αεροδρόμιο, δύο διανυκτερεύσεις, φαγητό και ταξί.",
          "lead": "Ένα σύντομο ταξίδι όπου η πτήση μοιάζει το βασικό έξοδο. Στην πράξη οι δύο διανυκτερεύσεις, το φαγητό και η διαδρομή από το αεροδρόμιο μαζί ξεπερνούν συχνά το εισιτήριο.",
          "includes": [
            "Μεταφορά από το αεροδρόμιο στην πόλη — μία ώρα",
            "Δύο διανυκτερεύσεις στην πόλη",
            "Φαγητό για τρεις ημέρες",
            "Ταξί μέσα στην πόλη — δύο διαδρομές",
            "Ασφάλεια"
          ],
          "add": "Αποσκευές, αν δεν ταξιδεύεις μόνο με χειραποσκευή, και την επιστροφή στο αεροδρόμιο αν τη μετράς χωριστά."
        },
        "beach": {
          "title": "Μια εβδομάδα στη θάλασσα",
          "description": "Ο προϋπολογισμός μιας εβδομάδας σε ένα μέρος: μεταφορά ως το ξενοδοχείο, επτά διανυκτερεύσεις, φαγητό, εκδρομές, σύνδεση και ασφάλεια.",
          "lead": "Επτά διανυκτερεύσεις σε ένα μέρος: η πτήση μετριέται μία φορά και όλα τα υπόλοιπα πολλαπλασιάζονται με τις ημέρες — άρα το σύνολο το κρίνουν η διανυκτέρευση και η μέρα, όχι τα εισιτήρια.",
          "includes": [
            "Μεταφορά από το αεροδρόμιο στο ξενοδοχείο — 45 λεπτά",
            "Επτά διανυκτερεύσεις",
            "Φαγητό για επτά ημέρες",
            "Εκδρομές και εισιτήρια",
            "Σύνδεση ή eSIM",
            "Ασφάλεια"
          ],
          "add": "Αποσκευές, ενοικιαζόμενο αυτοκίνητο και την εγγύησή του, αν το ταξίδι δεν είναι μόνο για την παραλία."
        },
        "business": {
          "title": "Επαγγελματικό ταξίδι",
          "description": "Ο προϋπολογισμός ενός ταξιδιού για δουλειά: τρεις διανυκτερεύσεις, ταξί, φαγητό, σύνδεση και ασφάλεια — αυτά που πάνε μετά στα έξοδα.",
          "lead": "Το ταξίδι για δουλειά μετριέται αλλιώς: λίγες διανυκτερεύσεις και πολλά ταξί, και από πριν δεν χρειάζεται μια μέση εκτίμηση αλλά ένα ποσό που θα δεχτεί το λογιστήριο.",
          "includes": [
            "Μεταφορά από το αεροδρόμιο — μία ώρα",
            "Τρεις διανυκτερεύσεις",
            "Ταξί μέσα στην πόλη — τέσσερις διαδρομές",
            "Φαγητό για τέσσερις ημέρες",
            "Σύνδεση ή eSIM",
            "Ασφάλεια"
          ],
          "add": "Αποσκευές και ό,τι πληρώνει χωριστά η εταιρεία: αυτό βολεύει να μένει ως δεύτερη επιλογή δίπλα."
        },
        "two-cities": {
          "title": "Δύο πόλεις σε ένα ταξίδι",
          "description": "Ο προϋπολογισμός ενός ταξιδιού σε δύο πόλεις: τρεις διανυκτερεύσεις σε κάθε μία, η μεταφορά ανάμεσά τους, φαγητό και ταξί.",
          "lead": "Δύο πόλεις σε ένα ταξίδι προσθέτουν αυτό που δεν έχει το ταξίδι σε μία: μια μεταφορά στη μέση που κοστίζει και χρήματα και μισή μέρα.",
          "includes": [
            "Τρεις διανυκτερεύσεις στην πρώτη πόλη",
            "Μεταφορά ανάμεσα στις πόλεις — τέσσερις ώρες",
            "Τρεις διανυκτερεύσεις στη δεύτερη πόλη",
            "Φαγητό για επτά ημέρες",
            "Ταξί — τέσσερις διαδρομές",
            "Ασφάλεια"
          ],
          "add": "Αποσκευές και, αν οι πόλεις είναι σε διαφορετικές χώρες, βίζα και ασφάλεια που καλύπτει και τις δύο."
        },
        "mountains": {
          "title": "Βουνό και σκι",
          "description": "Ο προϋπολογισμός ενός ταξιδιού στο βουνό: πέντε διανυκτερεύσεις δίπλα στην πίστα, αναβατήρας, ενοικίαση εξοπλισμού, φαγητό και ασφάλεια.",
          "lead": "Στο βουνό ακριβό δεν είναι το κατάλυμα αλλά η μέρα στην πίστα: ο αναβατήρας και η ενοικίαση μετριούνται με τις ημέρες και σε μια εβδομάδα φτάνουν την πτήση.",
          "includes": [
            "Μεταφορά από το αεροδρόμιο — μία ώρα",
            "Πέντε διανυκτερεύσεις δίπλα στην πίστα",
            "Αναβατήρας για πέντε ημέρες",
            "Ενοικίαση εξοπλισμού για πέντε ημέρες",
            "Φαγητό για έξι ημέρες",
            "Ασφάλεια"
          ],
          "add": "Αποσκευή για τα σκι, μαθήματα με εκπαιδευτή και ασφάλεια που καλύπτει πράγματι το σκι."
        }
      }
    }
  },
  "zh": {
    "nav": {
      "home": "规划器",
      "pricing": "价格"
    },
    "about": {
      "title": "关于本服务",
      "description": "Plan Your Trip 是旅行费用规划器：把航班、接送、住宿和各种花销拼成预算，按价格和时间比较不同方案。",
      "lead": "Plan Your Trip 让你在还能改的时候，看清一次旅行到底要花多少。",
      "sections": [
        {
          "h": "为什么需要它",
          "p": [
            "机票价不等于旅行价。行李、机场往返、住宿、吃饭，还有十来项零碎开销：单看每一项都不起眼，加在一起却决定了哪个方案更便宜。",
            "半价的早班机，一旦算上凌晨打车和路上耗掉的一天，就不再便宜。只有把旅行的所有部分放在一处，这件事才看得见。"
          ]
        },
        {
          "h": "怎么运作",
          "p": [
            "一次旅行由若干「块」拼成：航班、接送、住宿、吃饭、行李和其他花销。块组成方案，通常两三个：「经伊斯坦布尔转机」「提前一天走」「坐火车不坐飞机」。",
            "方案并排摆着，同时按两个数比较：花多少钱、用多少时间。金额换算成同一种货币，按人头算的开销会乘以出行人数。"
          ]
        },
        {
          "h": "它不做什么",
          "p": [
            "本服务不搜航班、不卖机票，也不从订单里抽成。里面的价格是你自己的：手动填写，或者用识别从订单里提取。",
            "所以它没有理由把某个方案显示得更划算：它只负责计算和比较，不做买卖。"
          ]
        },
        {
          "h": "数据存在哪里",
          "p": [
            "不注册时，行程只存在浏览器里，不会外传。注册账号是为了让它在所有设备上都能打开、可以两个人一起维护，也可以用链接展示。",
            "公开链接只展示你分享的内容，看的人改不了任何东西，链接本身随时可以停用。"
          ]
        }
      ]
    },
    "how": {
      "title": "怎么用",
      "description": "怎样算一次旅行的预算：把开销拼成块、排出方案、按价格和时间比较，再用链接分享。无需注册。",
      "lead": "五步，从空白页面走到答案：哪个方案更便宜，省下的每小时又值多少钱。",
      "stepsTitle": "五个步骤",
      "steps": [
        {
          "h": "先攒素材库",
          "p": "素材库里放的是旅行的各个部分：航班、接送、住宿、吃饭、行李、保险。航班不必手打：把订单链接或确认邮件的正文粘进来，识别会取出日期、机场、时间和价格。"
        },
        {
          "h": "排出方案",
          "p": "一个方案就是一种走法：把块按发生顺序拖到它那一行。顺序就是行程，块与块之间的空隙就是等待时间，同样看得见。"
        },
        {
          "h": "按价格和时间比较",
          "p": "方案并排放在同一张表里：总价、按开销类型的明细，以及总时长。差别一眼就能看出来——既是钱，也是路上花掉的小时数。"
        },
        {
          "h": "设置货币和人数",
          "p": "金额可以用不同货币：汇率对基准货币设一次，比较用你选的那种。航班、行李、吃饭和打车按出行人数相乘；住宿和接送只有标记为「按人头」时才乘。"
        },
        {
          "h": "分享链接",
          "p": "公开链接让没有行程的人也能看到：名称、方案比较，以及每个方案的构成。看的人改不了任何东西，也不用注册，链接随时可以关闭。"
        }
      ],
      "faqTitle": "常见问题",
      "faq": [
        {
          "q": "必须注册吗？",
          "a": "不必。没有账号时行程保存在浏览器里，可以直接开始。需要在多台设备上使用、和别人一起编辑，或者用公开链接分享时，才需要账号。"
        },
        {
          "q": "这个服务搜票、卖票吗？",
          "a": "不。它不搜航班、不代订，也不抽成。价格由你填写——手动或者用订单识别——服务负责相加和比较。"
        },
        {
          "q": "价格从哪来？",
          "a": "来自你在航司或自己订单里看到的数字。没有任何金额会按「大概」填上：拍脑袋的价格会悄悄进入总价，让比较失真。"
        },
        {
          "q": "多人出行怎么算？",
          "a": "航班、行李、吃饭和打车按人数相乘。住宿和接送默认算共用，除非你把它们标为「按人头」：一间双人房，住几个人价钱都一样。"
        },
        {
          "q": "可以用多种货币吗？",
          "a": "可以。每笔金额有自己的货币，汇率对基准货币设定，总价和比较按你选的货币显示。"
        },
        {
          "q": "收到链接的人能看到什么？",
          "a": "行程名称、比较表格，以及每个方案的构成——外观和语言就是你分享时的样子。对方改不了任何东西，链接也可以停用。"
        },
        {
          "q": "多少钱？",
          "a": "主要功能免费，且没有时间限制：行程、方案、比较和链接。付费方案提高额度并增加功能——具体包含什么写在价格页面上。"
        }
      ],
      "cta": "打开规划器"
    },
    "templates": {
      "title": "行程模板",
      "description": "常见旅行的现成开销清单：周末两日、海边一周、出差、两座城市、雪山。一键在规划器中打开。",
      "lead": "模板不是填好价格的现成行程，而是这类旅行通常包含哪些开销的清单。价格由你来填：拍脑袋的数字会悄悄进入总价，让比较失真。",
      "listTitle": "五个模板",
      "includesTitle": "包含什么",
      "addTitle": "还值得加上",
      "cta": "用这个模板拼一次行程",
      "ctaNote": "模板会在规划器中打开：块已排好，价格是空的。",
      "backToList": "全部模板",
      "items": {
        "weekend": {
          "title": "周末两日",
          "description": "周末出行的预算由什么构成：机场往返、两晚住宿、吃饭和打车。模板可在规划器中打开。",
          "lead": "短途出行，看上去机票是大头。实际上两晚住宿、吃饭加上机场往返，往往合起来超过机票。",
          "includes": [
            "机场到市区的接送——一小时",
            "市内两晚",
            "三天的吃饭",
            "市内打车——两趟",
            "保险"
          ],
          "add": "如果不是只带随身行李，加上托运行李；返程去机场如果单算，也加上。"
        },
        "beach": {
          "title": "海边一周",
          "description": "在一个地方待一周的预算：酒店接送、七晚住宿、吃饭、当地游玩、通信和保险。模板可在规划器中打开。",
          "lead": "七晚都在一个地方：机票只算一次，其余都按天数相乘——所以决定总价的是每一晚和每一天，而不是机票。",
          "includes": [
            "机场到酒店的接送——45 分钟",
            "七晚住宿",
            "七天的吃饭",
            "当地游玩和门票",
            "通信或 eSIM",
            "保险"
          ],
          "add": "托运行李、租车和押金，如果这趟不只是躺沙滩。"
        },
        "business": {
          "title": "出差",
          "description": "因公出行的预算：三晚住宿、打车、吃饭、通信和保险——之后都要进报销单。模板可在规划器中打开。",
          "lead": "出差的算法不一样：住得少、打车多，事先要的不是一个平均估计，而是财务能认的数字。",
          "includes": [
            "机场接送——一小时",
            "三晚住宿",
            "市内打车——四趟",
            "四天的吃饭",
            "通信或 eSIM",
            "保险"
          ],
          "add": "托运行李，以及公司单独支付的部分：那部分放成旁边的第二个方案更省事。"
        },
        "two-cities": {
          "title": "一趟走两座城",
          "description": "两座城市的行程预算：每城三晚、城际交通、吃饭和打车。模板可在规划器中打开。",
          "lead": "一趟走两座城，会多出单城行程没有的东西：中间那段城际交通，既花钱又花掉半天。",
          "includes": [
            "第一座城三晚",
            "城际交通——四小时",
            "第二座城三晚",
            "七天的吃饭",
            "打车——四趟",
            "保险"
          ],
          "add": "托运行李；如果两座城在不同国家，还要签证和能覆盖两国的保险。"
        },
        "mountains": {
          "title": "雪山滑雪",
          "description": "雪山之行的预算：雪场旁五晚、缆车票、装备租赁、吃饭和保险。模板可在规划器中打开。",
          "lead": "在雪山，贵的不是住宿而是雪场上的一天：缆车票和装备租赁按天算，一周下来能追上机票。",
          "includes": [
            "机场接送——一小时",
            "雪场旁五晚",
            "五天缆车票",
            "五天装备租赁",
            "六天的吃饭",
            "保险"
          ],
          "add": "雪具的托运费、教练课，以及真正覆盖滑雪的保险。"
        }
      }
    }
  }
}
